import React, { useEffect, useState } from 'react'
import { Button } from '../../../components'
import { Link } from 'react-router-dom'
import { posDisplaySize } from '../settings'

export function NavTabs(props) {
  const {
    size = 'auto', // or "100px"
    direction = 'column', // row | column
    children,
    variant = 'info',
  } = props

  const [selectedName, setSelectedName] = useState('')

  useEffect(() => {
    React.Children.map(children, (child, i) => {
      if (i === 0) setSelectedName(child.props.name)
      return null
    })
  }, [children])

  const commonStyles = {
    wrap: {
      display: 'flex',
      flexDirection: direction,
      padding: "0px 15px",
      // marginLeft: 15, marginRight: 15,
      // backgroundColor: "yellow",
      flex: 1
    },
    navTabs: {
      width: direction === 'column' ? '100%' : '30%',
      padding: "5px 0px",
      // backgroundColor: "orange",
      display: 'flex',
      flexDirection: direction === 'column' ? 'row' : 'column',
      flexWrap: 'wrap',
      alignItems: 'center',
      borderBottom: '2px solid gray'
    },
    btn: {
      width: size,
      marginRight: 2,
    },
    child: {
      flex: 1,
    },
  }

  return (
    <div style={commonStyles.wrap}>
      <div style={commonStyles.navTabs}>
        {React.Children.map(children, (child, i) => {
          let btnVariant = 'outline-' + variant
          if (child.props.variant) {
            btnVariant = child.props.variant
          }
          if (child.props.name === selectedName) {
            btnVariant = variant
          }
          return (
            <Button
              style={commonStyles.btn}
              key={i}
              title={child.props.name}
              variant={btnVariant}
              onClick={() => setSelectedName(child.props.name)}
            />
          )
        })}
      </div>

      {React.Children.map(children, (child, i) => {
        if (child.props.name === selectedName) {
          return React.cloneElement(child, { index: i })
        } else {
          return null
        }
      })}
    </div>
  )
}

export function NavBar(props) {
  const { links, gStyle, colors } = props

  const linkStyle = { ...gStyle.text, marginRight: 15 }

  const styles = {
    wrap: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingLeft: 15,
      height: posDisplaySize.headerHeight,
      backgroundColor: colors.dark,
    },
    link: { ...linkStyle, color: colors.light },
    linkActive: { ...linkStyle, color: colors.info },
  }

  return (
    <div style={styles.wrap}>
      <div style={{ flex: 1 }}>
        {links &&
          links.map((link, i) => {
            const linkStyle =
              link.path === window.location.pathname
                ? styles.linkActive
                : styles.link
            return (
              <Link key={i} style={linkStyle} to={link.path}>
                {link.name}
              </Link>
            )
          })}
      </div>

      <Link style={styles.link} to="/pos">
        POS HOME
      </Link>
    </div>
  )
}
